import { c as _c } from "react/compiler-runtime";
import { LibraryItem } from '@/components/page-builder/global/library/LibraryItem';
import { Tile } from '@/components/shared/components/Tile/Tile';
import { cn } from '@/lib/styles';
import type { GridCardProps, GridTypeProps } from '@/types/general';
import type { ServerRenderedEntry } from '@/types/helpers';
export const GridEntries = t0 => {
  const $ = _c(8);
  const {
    entries,
    type
  } = t0;
  const t1 = (type === "library" || type === "apps") && "xl:grid-cols-3";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("grid grid-cols-1 sm:grid-cols-2 gap-y-6 lg:gap-y-8 gap-x-7.5 w-full", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== entries || $[3] !== type) {
    t3 = entries?.map((entry, i) => {
      switch (type) {
        case "library":
          {
            return <LibraryItem entryItem={entry} key={entry.id} loading={i > 5 ? "lazy" : "eager"} fetchPriority={i > 5 ? "low" : "high"} />;
          }
        case "partners":
        case "apps":
          {
            return <Tile variant="integrations" {...entry} key={entry.id} />;
          }
        default:
          {
            return null;
          }
      }
    });
    $[2] = entries;
    $[3] = type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};